import type { TenantConfig } from "./types";

// zy — sibling school tenant. Brand assets are placeholders until zy
// supplies their own logo + colors. Matches the operator template at
// tenants/zy.env.example.
export const zyTenant: TenantConfig = {
  slug: "zy",
  displayName: "ZY School",
  tagline: "School AI Portal",
  defaultLocale: "zh-CN",
  subjects: [
    { agentId: "chemistry-assistant", labelKey: "chat.subjects.chemistry" },
    { agentId: "math-assistant", labelKey: "chat.subjects.math" },
    { agentId: "english-assistant", labelKey: "chat.subjects.english" },
  ],
  brand: {
    logoSrc: "/brand/favicon.svg",
  },
};
